import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';

const AdminLayout = () => {
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const { userRole, isLoading: authLoading } = useAuth();

	const skipAdminBody =
		pathname === '/admin/users' ||
		pathname === '/admin/users/' ||
		pathname === '/admin/errors' ||
		pathname === '/admin/errors/';

	useEffect(() => {
		if (authLoading) {
			return;
		}
		const allowed = ['admin', 'superAdmin'].includes(userRole);
		if (!allowed) {
			navigate('/404');
		}
	}, [navigate, authLoading, userRole]);

	if (authLoading) {
		return (
			<div className='admin-layout admin-layout--loading'>
				<p>Laster…</p>
			</div>
		);
	}

	if (!['admin', 'superAdmin'].includes(userRole)) {
		return null;
	}

	return (
		<div className='admin-layout'>
			{skipAdminBody ? (
				<Outlet />
			) : (
				<div className='admin-layout__body'>
					<Outlet />
				</div>
			)}
		</div>
	);
};

export default AdminLayout;
